import { useChainsFetchChainNodesDetailQuery } from 'modules/chains/actions/fetchChainNodesDetail';
import { useFetchBlockchainsQuery } from 'modules/chains/actions/fetchBlockchains';
import { useShouldSignInFromChainPage } from 'modules/chains/hooks/useShouldSignInFromChainPage';

export const useBlockchainsLoader = () => {
  const skip = useShouldSignInFromChainPage();

  useFetchBlockchainsQuery(undefined, { skip });
  useChainsFetchChainNodesDetailQuery(undefined, { skip });
};
